import React, { useReducer } from 'react';
import axios from 'axios';
import { configJSON } from '../../config/requestConfig';
import GameContext from './gameContext';
import gameReducer from './gameReducer';
import {
  msgSuccessSB,
  msgFailureSB,
  optionsSuccessSB,
  optionsFailureSB,
} from '../../config/snackBar';
import {
  GET_GAMES,
  GET_GAME,
  GET_RESULTS_GAME,
  GET_RESULT_GAME,
  SET_LOADING_GAME,
  GAME_ERROR,
  CLEAR_ERRORS_GAME,
  CLEAR_DATA_GAME,
} from '../types';

const GameState = (props) => {
  const initialState = {
    games: [],
    game: {},
    answers: [],
    answer: {},
    loading: false,
    errors: null,
  };

  const [state, dispatch] = useReducer(gameReducer, initialState);

  // Fetch all games
  const getGames = async () => {
    try {
      setLoading();
      const res = await axios.get('/api/v1/games');
      dispatch({
        type: GET_GAMES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Fetch all games with published true
  const getGamesWithPublishedTrue = async () => {
    try {
      setLoading();
      const res = await axios.get('/api/v1/games/published');
      dispatch({
        type: GET_GAMES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Fetch single game
  const getGame = async (id) => {
    try {
      setLoading();
      const res = await axios.get(`/api/v1/games/${id}`);
      dispatch({
        type: GET_GAME,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Create a new game
  const createGame = async (formData, history, enqueueSnackbar) => {
    try {
      setLoading();
      await axios.post(`/api/v1/games`, formData, configJSON);
      enqueueSnackbar(msgSuccessSB, optionsSuccessSB);
      history.push('/app/administration/games');
    } catch (error) {
      enqueueSnackbar(msgFailureSB, optionsFailureSB);
      dispatch({
        type: GAME_ERROR,
        payload: error.response.data.errors,
      });
    }
  };

  // Update game
  const updateGame = async (id, formData, history, enqueueSnackbar) => {
    try {
      setLoading();
      await axios.put(`/api/v1/games/${id}`, formData, configJSON);
      enqueueSnackbar(msgSuccessSB, optionsSuccessSB);
      history.push('/app/administration/games');
    } catch (err) {
      enqueueSnackbar(msgFailureSB, optionsFailureSB);
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Update published game
  const updatePublishedGame = async (id, formData, enqueueSnackbar) => {
    try {
      setLoading();
      await axios.put(`/api/v1/games/${id}/published`, formData, configJSON);
      enqueueSnackbar(msgSuccessSB, optionsSuccessSB);
    } catch (err) {
      enqueueSnackbar(msgFailureSB, optionsFailureSB);
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Delete game
  const deleteGame = async (id, enqueueSnackbar) => {
    try {
      setLoading();
      await axios.delete(`/api/v1/games/${id}`, configJSON);
      enqueueSnackbar(msgSuccessSB, optionsSuccessSB);
    } catch (err) {
      enqueueSnackbar(msgFailureSB, optionsFailureSB);
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Get answers game
  const getAnswersGame = async (id) => {
    try {
      setLoading();
      const res = await axios.get(`/api/v1/games/${id}/answers`);
      dispatch({
        type: GET_RESULTS_GAME,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Get answer game
  const getAnswerGame = async (gameId, answerId) => {
    try {
      setLoading();
      const res = await axios.get(
        `/api/v1/games/${gameId}/answers/${answerId}`
      );
      dispatch({
        type: GET_RESULT_GAME,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Delete answer game
  const deleteAnswerGame = async (gameId, answerId, enqueueSnackbar) => {
    try {
      setLoading();
      await axios.delete(`/api/v1/games/${gameId}/answers/${answerId}`);
      enqueueSnackbar(msgSuccessSB, optionsSuccessSB);
    } catch (err) {
      enqueueSnackbar(msgFailureSB, optionsFailureSB);
      dispatch({
        type: GAME_ERROR,
        payload: err.response.data.errors,
      });
    }
  };

  // Set Loading
  const setLoading = async () => {
    dispatch({
      type: SET_LOADING_GAME,
    });
  };

  // Clear errors
  const clearErrorsGame = async () => {
    dispatch({
      type: CLEAR_ERRORS_GAME,
    });
  };

  // Clear data
  const clearDataGame = async () => {
    dispatch({
      type: CLEAR_DATA_GAME,
    });
  };

  return (
    <GameContext.Provider
      value={{
        games: state.games,
        game: state.game,
        answers: state.answers,
        answer: state.answer,
        errors: state.errors,
        loading: state.loading,
        getGames,
        getGamesWithPublishedTrue,
        getGame,
        createGame,
        updateGame,
        updatePublishedGame,
        deleteGame,
        getAnswersGame,
        getAnswerGame,
        deleteAnswerGame,
        clearErrorsGame,
        clearDataGame,
      }}
    >
      {props.children}
    </GameContext.Provider>
  );
};

export default GameState;
